
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rentals-network/[[...slug]]",
      function () {
        return require("private-next-pages/rentals-network/[[...slug]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rentals-network/[[...slug]]"])
      });
    }
  